/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelCarrierCallinHistory.ts          *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/dispatch/carrier-callin-history";

export class AutogenModelCarrierCallinHistory<RowType extends ModelRow> extends Endpoint<RowType, RowCarrierCallinHistoryFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowCarrierCallinHistory extends ModelRow<RowCarrierCallinHistoryFields> {
	constructor(values?: Partial<RowCarrierCallinHistoryFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowCarrierCallinHistoryFields {
	ach_batch_class_code: string;
	actual_arrival: Date;
	actual_departure: Date;
	add_fed_to_wh: number;
	add_fed_to_wh_c: string;
	add_fed_to_wh_d: Date;
	add_fed_to_wh_n: number;
	add_fed_to_wh_r: number;
	addl_st_to_whold: number;
	addl_st_to_whold_c: string;
	addl_st_to_whold_d: Date;
	addl_st_to_whold_n: number;
	addl_st_to_whold_r: number;
	address: string;
	address1: string;
	address2: string;
	adp_co_code: string;
	adp_e_no: string;
	appointment_status_id: string;
	appt_contact_name: string;
	appt_required: string;
	birth_date: Date;
	call_date_time: Date;
	callin_script_results: string;
	callin_script_template: string;
	cases: number;
	check_address: string;
	check_address2: string;
	check_city: string;
	check_city_st_zip: string;
	check_date: Date;
	check_name: string;
	check_number: string;
	check_st: string;
	check_stub_comment: string;
	check_zip: string;
	city: string;
	city_amt_to_whold: number;
	city_amt_to_whold_c: string;
	city_amt_to_whold_d: Date;
	city_amt_to_whold_n: number;
	city_amt_to_whold_r: number;
	city_exemptions: number;
	city_id: number;
	city_name: string;
	city_tax_code: string;
	company_id: string;
	confirmed: string;
	contact_email: string;
	contact_name: string;
	country_id: string;
	county_amt_to_whold: number;
	county_amt_to_whold_c: string;
	county_amt_to_whold_d: Date;
	county_amt_to_whold_n: number;
	county_amt_to_whold_r: number;
	county_exemptions: number;
	county_tax_code: string;
	created_by: string;
	currency: string;
	current_stop_id: string;
	dependents: number;
	dependents_c: string;
	dependents_d: Date;
	dependents_n: number;
	dependents_r: number;
	disable_payroll_taxes: string;
	dist_from_prev: number;
	dist_from_prev_um: string;
	driver_id: string;
	driver_load_unload: string;
	edi_code: string;
	edi_loc_code: string;
	eft_first_name: string;
	eft_individual: string;
	eft_last_name: string;
	eft_middle_initial: string;
	email: string;
	email_summary: string;
	enable_carrier_app: string;
	entered_by: string;
	entered_date: Date;
	equipment_group_id: string;
	eta: Date;
	eta_distance: number;
	eta_late: string;
	eta_oor: string;
	exempt_from_fed: string;
	exempt_from_state: string;
	extra_withholdings: number;
	extra_withholdings_c: string;
	extra_withholdings_d: Date;
	extra_withholdings_n: number;
	extra_withholdings_r: number;
	fed_amt_to_whold: number;
	fed_amt_to_whold_c: string;
	fed_amt_to_whold_d: Date;
	fed_amt_to_whold_n: number;
	fed_amt_to_whold_r: number;
	fed_exemptions: number;
	fed_marital_status: string;
	freeze_pay: string;
	freight_matching_override: string;
	google_place_id: string;
	gp_exclude: string;
	gp_exported: Date;
	gp_imported: Date;
	gps_accuracy: number;
	grouped_id: number;
	hire_date: Date;
	holiday_hours_pd: number;
	hub: number;
	ic_stop_id: string;
	id: string;
	inbound_status: string;
	initiated_type: string;
	last_raise_date: Date;
	late_eta_colorcode: string;
	late_route_status: string;
	latitude: number;
	lease_number: string;
	legal_name: string;
	load_booking_eligible: string;
	loadpay_contact_phone: string;
	location_id: string;
	location_name: string;
	longitude: number;
	manifest_fgp_uid: number;
	manifest_reg_uid: number;
	miles2consignee: number;
	miles2consignee_um: string;
	move_dist_from_preassign: number;
	move_dist_from_preassign_um: string;
	move_dist_from_previous: number;
	move_dist_from_previous_um: string;
	movement_id: string;
	movement_sequence: number;
	movement_status: string;
	multiple_jobs: string;
	name: string;
	new_eta: Date;
	next_stop_avg_speed: number;
	next_stop_city_id: number;
	next_stop_city_name: string;
	next_stop_state: string;
	next_stop_time_left: number;
	next_stop_zip_code: string;
	non_office_emp: string;
	office_employee: string;
	operational_status: string;
	order_id: string;
	order_sequence: number;
	orig_sched_early: Date;
	orig_sched_late: Date;
	other_deductions: number;
	other_deductions_c: string;
	other_deductions_d: Date;
	other_deductions_n: number;
	other_deductions_r: number;
	other_income: number;
	other_income_c: string;
	other_income_d: Date;
	other_income_n: number;
	other_income_r: number;
	overtime_hours_pd: number;
	pallets_dropped: number;
	pallets_picked_up: number;
	payee_id: string;
	payment_code_reviewed: string;
	payment_method: string;
	phone: string;
	phone_number: string;
	planned_arrival_time: Date;
	ponum: string;
	posted_check_date: Date;
	prev_code: string;
	primary_agency: string;
	prior_uncleared_stops: string;
	projected_arrival: Date;
	pto_timeclock: number;
	pu_override_arrive_early: Date;
	pu_override_arrive_late: Date;
	rate_dist_from_previous: number;
	rate_dist_from_previous_um: string;
	refno: string;
	regular_hours_pd: number;
	remark: string;
	remarks: string;
	requested_service: string;
	sched_arrive_early: Date;
	sched_arrive_late: Date;
	sched_date_time: Date;
	seal: string;
	service_date: Date;
	setpoint_temp: number;
	setpoint_temp_um: string;
	settlement_status: string;
	showas_address: string;
	showas_address2: string;
	showas_city_id: number;
	showas_city_name: string;
	showas_location_id: string;
	showas_location_name: string;
	showas_state: string;
	showas_zip_code: string;
	sick_hours_pd: number;
	signed_for_name: string;
	social_security_no: string;
	st_amt_to_whold: number;
	st_amt_to_whold_c: string;
	st_amt_to_whold_d: Date;
	st_amt_to_whold_n: number;
	st_amt_to_whold_r: number;
	st_marital_status: string;
	state: string;
	state_exemptions: number;
	state_tax_code: string;
	status: string;
	stop_type: string;
	sui_tax_code: string;
	tank_operator: string;
	tax_table_city_aux: number;
	tax_table_city_misc: number;
	tax_table_county_aux: number;
	tax_table_county_misc: number;
	tax_table_fit_aux: number;
	tax_table_fit_misc: number;
	tax_table_st_aux: number;
	tax_table_st_misc: number;
	tax_table_sui_aux: number;
	tax_table_sui_misc: number;
	temperature: number;
	temperature_um: string;
	termination_date: Date;
	tractor_id: string;
	trimble_place_id: string;
	txl_uid: number;
	vacation_hours_pd: number;
	vm_part_update: string;
	volume: number;
	volume_um: string;
	w4_status: string;
	weight: number;
	weight_um: string;
	wf_queue: number;
	ytd_holiday_hrs: number;
	ytd_overtime_hrs: number;
	ytd_reg_hrs_paid: number;
	ytd_sick_hrs_paid: number;
	ytd_vacation_hrs: number;
	zip_code: string;
	zone_id: string;
}

